import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/home/synced-operations')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/dashboard/home/synced-operations"!</div>
}
